import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Container from '../../containers/Container'
import FooterMenu from '../FooterMenu'
import * as style from './style.module.scss'

const Footer = () => (
    <StaticQuery
        query={graphql`
            query FooterQuery {
                wpMenu(locations: { eq: FOOTER_MENU }) {
                    ...Menu
                }
                wp {
                    options {
                        acfOptions {
                            footerCopyrightLine
                        }
                    }
                }
            }
        `}
        render={(data) => (
            <footer className={style.footer}>
                <Container thin>
                    <div className={style.footerWrap}>
                        <FooterMenu menu={data?.wpMenu?.menuItems?.nodes} />
                        <div className={style.footerCopyright}>
                            <small>
                                {data.wp.options.acfOptions.footerCopyrightLine}
                            </small>
                        </div>
                    </div>
                </Container>
            </footer>
        )}
    />
)

export default Footer
